import { html } from 'lit';
import { FileX2 } from 'lucide-static';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { state } from 'lit/decorators.js';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-file-x')
export class PdsIconFileX extends PdsIcon {
  @state()
  icon = FileX2;

  render() {
    return html`${unsafeHTML(this.setIconAttributes())}`;
  }
}
